// src/router/MainRouter.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import GarmentDashboard from "../screens/admin/analytics/GarmentDashboard";
import HoursWorkedPivotTable from "../screens/admin/analytics/HoursWorkedPivotTable";
import LinkingProgressPivotTable from "../screens/admin/analytics/legacyAggregation/LinkingProgressPivotTable";
import LegacyAggregationAnalyticsDashboard from "../screens/admin/analytics/legacyAggregation/LegacyAggregationAnalyticsDashboard";
import GroupingProgressPivotTable from "../screens/admin/analytics/legacyAggregation/GroupingProgressPivotTable";
import CataloguingAnalyticsDashboard from "../screens/admin/analytics/cataloguing/CataloguingAnalyticsDashboard";
import CataloguingProgressPivotTable from "../screens/admin/analytics/cataloguing/CataloguingProgressPivotTable";
import GroupingSpeedPivotTable from "../screens/admin/analytics/legacyAggregation/GroupingSpeedPivotTable";
import CataloguingSpeedPivotTable from "../screens/admin/analytics/cataloguing/CataloguingSpeedPivotTable";
import LinkingSpeedPivotTable from "../screens/admin/analytics/legacyAggregation/LinkingSpeedPivotTable";
import ImageTaggingSpeedPivotTable from "../screens/admin/analytics/imageTagging/ImageTaggingDatasetProgressPivotTable";
import ImageTaggingAnalyticsDashboard from "../screens/admin/analytics/imageTagging/ImageTaggingAnalyticsDashboard";
import AggregationAnalyticsDashboard from "../screens/admin/analytics/aggregation/AggregationAnalyticsDashboard";
import AggregationSpeedPivotTable from "../screens/admin/analytics/aggregation/AggregationSpeedPivotTable";

const AnalyticsRoutes = () => {
  return (
    <Routes>
      <Route path="/garment/:id" element={<GarmentDashboard />} />
      <Route path="/hours-worked" element={<HoursWorkedPivotTable />} />
      <Route path="/legacy-aggregation" element={<LegacyAggregationAnalyticsDashboard />} />
      <Route path="/legacy-aggregation/progress" element={<LinkingProgressPivotTable fillPage={true}/>} />
      <Route path="/legacy-aggregation/speed" element={<LinkingSpeedPivotTable fillPage={true}/>} />
      <Route path="/legacy-aggregation/progress" element={<GroupingProgressPivotTable fillPage={true}/>} />
      <Route path="/legacy-aggregation/speed" element={<GroupingSpeedPivotTable fillPage={true}/>} />
      <Route path="/cataloguing" element={<CataloguingAnalyticsDashboard />} />
      <Route path="/cataloguing/progress" element={<CataloguingProgressPivotTable fillPage={true}/>} />
      <Route path="/cataloguing/speed" element={<CataloguingSpeedPivotTable fillPage={true}/>} />
      <Route path="/aggregation" element={<AggregationAnalyticsDashboard />} />
      <Route path="/aggregation/speed" element={<AggregationSpeedPivotTable fillPage={true}/>} />
      <Route path="/tagging/image-tagging/speed" element={<ImageTaggingSpeedPivotTable fillPage={true}/>} />
      <Route path="/tagging/image-tagging" element={<ImageTaggingAnalyticsDashboard />} />
    </Routes>
  );
};

export default AnalyticsRoutes;
